export function getAbsoluteSelection(editorState) {
  const selection = editorState.getSelection()
  const startKey = selection.getStartKey()
  const startOffset = selection.getStartOffset()
  const endKey = selection.getEndKey()
  const endOffset = selection.getEndOffset()
  const blockMap = editorState.getCurrentContent().getBlockMap()

  const { start, end } = blockMap.reduce(
    function (r, block, blockKey) {
      return null != r.start && null != r.end
        ? r
        : {
            start: blockKey == startKey ? r.offset + startOffset : r.start,
            end: blockKey == endKey ? r.offset + endOffset : r.end,
            offset: r.offset + block.getLength() + 1
          }
    },
    { start: null, end: null, offset: 0 }
  )

  return { start: start || 0, end: end || 0 }
}

export function setAbsoluteSelection(editorState, absoluteSelection) {
  const selection = editorState.getSelection()
  const blockMap = editorState.getCurrentContent().getBlockMap()
  const { startKey, startOffset, endKey, endOffset } = blockMap.reduce(
    function (r, block, blockKey) {
      if (null != r.startKey && null != r.startOffset && null != r.endKey && null != r.endOffset) {
        return r
      } else {
        const blockLength = block.getLength()
        const inStartBlock = r.offset <= absoluteSelection.start && absoluteSelection.start <= r.offset + blockLength
        const inEndBlock = r.offset <= absoluteSelection.end && absoluteSelection.end <= r.offset + blockLength
        return {
          startKey: inStartBlock ? blockKey : r.startKey,
          startOffset: inStartBlock ? absoluteSelection.start - r.offset : r.startOffset,
          endKey: inEndBlock ? blockKey : r.startKey,
          endOffset: inEndBlock ? absoluteSelection.end - r.offset : r.startOffset,
          offset: r.offset + blockLength + 1
        }
      }
    },
    { startKey: null, startOffset: null, endKey: null, endOffset: null, offset: 0 }
  )
  if (null == endKey || null == endOffset) {
    const lastBlock = blockMap.last()
    const lastBlockKey = lastBlock.getKey()
    const lastBlockLength = lastBlock.getLength()
    return selection.merge({
      anchorKey: startKey || lastBlockKey,
      anchorOffset: startOffset || lastBlockLength,
      focusKey: lastBlockKey,
      focusOffset: lastBlockLength,
      isBackward: false
    })
  } else {
    return selection.merge({
      anchorKey: startKey,
      anchorOffset: startOffset,
      focusKey: endKey,
      focusOffset: endOffset,
      isBackward: false
    })
  }
}

export function setSelectionAfterUpdate(nextEditorState, prevEditorState) {
  const nextText = nextEditorState.getCurrentContent().getPlainText('\n')
  const nextTextLength = nextText.length
  const prevText = prevEditorState.getCurrentContent().getPlainText('\n')
  const prevTextLength = prevText.length
  const absoluteSelection = getAbsoluteSelection(prevEditorState)
  if (nextTextLength == prevTextLength) {
    // keep old selection
    return setAbsoluteSelection(nextEditorState, absoluteSelection)
  } else if (nextTextLength > prevTextLength) {
    // inserted block
    let matchTail = 0
    const tailBorder = nextTextLength - absoluteSelection.start
    const lengthDiff = nextTextLength - prevTextLength
    for (; matchTail < tailBorder; matchTail++) {
      const tailIndex = nextTextLength - matchTail - 1
      if (nextText[tailIndex] != prevText[tailIndex - lengthDiff]) break
    }
    const setAbsoluteSelectionTo = nextTextLength - matchTail
    return setAbsoluteSelection(nextEditorState, { start: setAbsoluteSelectionTo, end: setAbsoluteSelectionTo })
  } else {
    // removed block
    let matchHead = 0
    for (; matchHead < absoluteSelection.start; matchHead++) {
      if (nextText[matchHead] != prevText[matchHead]) break
    }
    const setAbsoluteSelectionTo = matchHead
    return setAbsoluteSelection(nextEditorState, { start: setAbsoluteSelectionTo, end: setAbsoluteSelectionTo })
  }
}
